<template>
  <div class="p-3 flex flex-col gap-2 bg-key rounded-4xl">
    <div class="flex items-center py-1.5 gap-1 text-l-medium text-black-white">
      <Icon icon="Function-Wireframe-WindowSize" class="size-6" />
      <span>{{ $t('setting.about.run.title') }}</span>
    </div>

    <div class="flex flex-col items-center justify-between gap-2">
      <!-- Auto Start -->
      <div class="p-2 flex flex-col gap-2 w-full bg-neutral-light-default rounded-xl">
        <div class="flex justify-between items-center">
          <span class="text-m-medium text-black-white">
            {{ $t('setting.about.run.autoStartLabel') }}
          </span>
          <Switch v-model="start.auto" size="lg" />
        </div>
        <div class="flex justify-between items-center">
          <span class="text-s-medium text-text-glass-default">
            {{ $t('setting.about.run.silentBackgroundLabel') }}
          </span>
          <Checkbox v-model="start.silence" class="size-3 border-black-white" />
        </div>
      </div>

      <!-- Close Behavior Toggle -->
      <div class="w-full bg-neutral-light-default p-2 rounded-xl">
        <div
          class="flex items-center justify-between w-full bg-neutral-light-default rounded-full gap-0.5 h-10 text-m-medium"
        >
          <div
            class="flex-1 py-2 transition-colors text-center cursor-pointer rounded-full"
            :class="[
              closeBehavior === 'minimize'
                ? 'bg-brand-blue1 text-white'
                : 'text-black-white hover:text-text-glass-hover',
            ]"
            @click="closeBehavior = 'minimize'"
          >
            {{ $t('setting.about.run.closeActionOptions.minimize') }}
          </div>
          <div
            class="flex-1 py-2 transition-colors text-center cursor-pointer rounded-full"
            :class="[
              closeBehavior === 'exit'
                ? 'bg-brand-blue1 text-white'
                : 'text-black-white hover:text-text-glass-hover',
            ]"
            @click="closeBehavior = 'exit'"
          >
            {{ $t('setting.about.run.closeActionOptions.exit') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { Icon, Switch, Checkbox } from '@rapoo/element'
  import { usePreferenceStore } from '@/stores'
  import { storeToRefs } from 'pinia'
  const preferenceStore = usePreferenceStore()
  const { start, closeBehavior } = storeToRefs(preferenceStore)
</script>
